export const nav = {
  product: "Programme",
  roadmap: "Roadmap",
  customers: "Éligibilité",
  pricing: "Offre",
  contact: "Contact",
  tryKlark: "Rejoignez",
  menu: "Menu"
};

export const links = {
  applyUrl: "https://tally.so/r/n9brL4"
};

export const hero = {
  earlyAdopter: "Programme d'affiliation",
  headline: "Et si votre réseau vous permettait",
  headlineAccent: "d'améliorer vos revenus et votre business ?",
  subheadline: "Co-construisons Klark au travers de notre programme d'affiliation. Que vous soyez, entrepreneurs, professionnels, ou convaincus par notre solution, ce programme est fait pour vous.",
  joinEarlyAdopters: "Candidatez",
  watchDemo: "Voir la démo",
  aiActive: "Bêta-test",
  revenueGrowth: "Croissance du chiffre d'affaires"
};

export const affiliation = {
  primaryTitle: "Transformez votre réseau en",
  titleAccent: "revenus",
  subtitle: "Rejoignez notre programme d'affiliation et commencez à générer vos premiers revenus",
  youCanEarn: "Gagnez jusqu'à",
  perMonth: "par mois",
  description: "Basé sur l'offre Klark de 49€/mois avec 25% de commission",
  referrals: "Parrainages",
  firstBoxTitle: "25% de commission",
  firstBoxDesc: "A vie pour chaque parrainage*",
  secondBoxTitle: "30 Jours",
  secondBoxDesc: "Commission reversée après ce délai",
  thirdBoxTitle: "Dashboard affiliation",
  thirdBoxDesc: "Bientôt disponible",
  affiliateButton: "Rejoindre le programme",
  footnote: "* Commission versée sous condition du paiement effectif de l'abonnement par le filleul.",
  firstStepTitle: "Candidatez",
  firstStepDesc: "Votre demande sera étudiée avant validation",
  secondStepTitle: "Partagez",
  secondStepDesc: "Diffusez votre code unique auprès de votre audience",
  thirdStepTitle: "Encaissez",
  thirdStepDesc: "Jusqu'a 25% de commission grâce à vos conversions",
};


export const pricing = {
  title: "Offre de lancement",
  subtitle: "Faites bénéficier ce prix exclusif à votre réseau, ainsi qu'un accès illimité à toutes les fonctionnalités IA. Les tarifs standards s'appliqueront après le lancement public.",
  toggleMonthly: "Mensuel",
  toggleAnnual: "Annuel",
  savingsBadge: "Économisez 55%",
  monthlyLabel: "MENSUEL",
  annualLabel: "ANNUEL",
  monthlyPrice: "49,99€",
  annualPrice: "23,25€",
  perMonthHT: "/ mois HT",
  monthlyBilled: "Facturé chaque mois, sans engagement",
  annualBilled: "279 € facturés annuellement",
  freeTrial: "7 jours d'essai gratuit",
  earlyAccess: "Early access — Offre exclusive",
  twoMonthsFree: "2 mois offerts inclus dans l'abonnement",
  features: {
    bankAggregation: "Agrégation de tous vos comptes bancaires",
    crm: "CRM clients cross-canaux",
    tools: "Accès à tous les outils (Fakture, Kalendar, Dokument...)",
    integrations: "Connexion Shopify, Stripe, PayPal, PrestaShop",
    partnerDiscounts: "Accès aux réductions partenaires",
    prioritySupport: "Support prioritaire",
    updates: "Mises à jour incluses"
  },
  promote: "Promouvoir",
  endsIn: "L'accès anticipé se termine dans :",
  timeUnits: {
    days: "jours",
    hours: "heures",
    minutes: "minutes",
    seconds: "secondes"
  },
  secureSpot: "Partager l'offre",
  savings: "Économie de 320€ par an • Sans engagement"
};

export const features = {
  title: "Comment présenter simplement",
  titleAccent: "ce qu'est Klark ?",
  subtitle: "Retrouvez ici l'ensemble des fonctionnalités qui évoluent selon les retours clients.",
  items: [
    {
      title: "Deep Learning",
      description: "L'IA Klark s'entraine sur vos données d'entreprise, seulement pour votre entreprise. "
    },
    {
      title: "Indicateurs financiers",
      description: "Synchronisez vos comptes bancaires pro et analysez vos flux de trésorerie instantanément."
    },
    {
      title: "Toutes vos datas en un seul endroit",
      description: "Synchronisez vos boutiques, produits et clients et gérez tout depuis Klark."
    },
    {
      title: "Outils améliorés par l'IA : productivité sans limites",
      description: "Devis, Fakture, MeetPlanner, Showkase, Digital Safe, Kaisse, Reminders, Kalkulator..."
    },
    {
      title: "Partenariats stratégiques",
      description: "Profitez de tarifs négociés auprès de nombreux partenaires de qualité."
    },
    {
      title: "Réseau d'entrepreneurs Klark",
      description: "Connectez-vous avec les bonnes personnes 24/7 sur Discord et durant les événements physiques Klark."
    },
    {
      title: "Une vision 360° sur votre business",
      description: "Centralisez, analysez, modifiez, planifiez depuis Klark en toute simplicité."
    },
    {
      title: "IA Co-Fondateur",
      description: "Votre allié IA qui pense, apprend et grandit au rythme de votre entreprise.  Dépassez vos propres limites."
    }
  ],
  betaAccess: "Bientôt disponible"
};

export const perks = {
  title: "Votre réseau économisera jusqu'à",
  titleAccent: "2 000 000€ sur leurs outils",
  subtitle: "Klark leur permet de bénéficier d'avantages exclusifs négociés auprès de +500 logiciels/progiciels/SaaS, parmi les meilleurs du marché.",
  askAccess: "Demander mon accès",
  brands: [
    "6 mois gratuits sur le forfait Business avec IA illimitée",
    "Frais Stripe offerts sur les prochains 20 000 $ de traitement de paiements",
    "25 % de réduction sur les abonnements annuels.",
    "25 % de réduction sur les nouveaux achats de forfaits",
    "90 % de réduction pendant 1 an",
    "14 jours gratuits + 33 % de réduction sur les abonnements annuels."
  ]
};

export const roadmap = {
  title: "Klark Roadmap",
  titleAccent: "les prochaines étapes",
  subtitle: "En rejoignant la communauté Klark, vous participerez au développement des améliorations futures",
  items: [
    {
      quarter: "T4 2025",
      title: "Implémentation de l'IA",
      description: "Bénéficiez de l'IA ajoutée à l'ensemble de vos outils Klark."
    },
    {
      quarter: "T1 2026",
      title: "Itérations IA Klark",
      description: "Déploiement de la version bêta de votre co-fondateur IA Klark."
    },
    {
      quarter: "T2 2026",
      title: "Implémentation MCP Serveur Klark + Programme bêta-testeurs",
      description: "Découvrez Klark Neural. Donnez vie à vos projets, votre business peut désormais penser."
    },
    {
      quarter: "T3 2026",
      title: "Commercialisation et amélioration produit",
      description: "Déploiement commercial de Klark en EU et USA, amélioration des outils en place."
    }
  ]
};

export const testimonials = {
  title: "A qui s'adresse",
  titleAccent: "notre programme ?",
  subtitle: "Comme de nombreuses entreprises, rejoignez la communauté d'entrepreneurs Klark",
  items: [
    {
      name: "Créateurs de contenus",
      role: "YouTubers, Infopreneurs, Instagram, TikTok LinkedIn, Telegram...",
      quote: "Diffusez votre code personnalisé de parrainage auprès de votre audience et maximisez vos revenus.",
      metrics: ""
    },
    {
      name: "Médias",
      role: "Bloggueurs, Rédacteurs, Journalistes Indépendants, Agences Web...",
      quote: "Recommandez Klark à vos lecteurs avec votre code personnalisé et monétisez votre influence.",
      metrics: ""
    },
    {
      name: "Formation & Accompagnement",
      role: "Incubateurs, Centres de formation, Écoles de commerce, Accélérateurs",
      quote: "Recommandez Klark aux entrepreneurs que vous accompagnez et bénéficiez de commissions récurrentes.",
      metrics: ""
    }
  ]
};

export const contact = {
  title: "Entrer en",
  titleAccent: "contact",
  subtitle: "Vous avez des questions sur Klark ? Envoyez-nous un message et nous répondrons dans les 24 heures.",
  form: {
    name: "Nom",
    email: "Email",
    company: "Entreprise",
    subject: "Sujet",
    message: "Message",
    namePlaceholder: "Votre nom complet",
    emailPlaceholder: "votre.email@entreprise.com",
    companyPlaceholder: "Nom de votre entreprise",
    subjectPlaceholder: "Comment pouvons-nous vous aider ?",
    messagePlaceholder: "Parlez-nous de vos besoins et comment nous pouvons vous aider...",
    maxChars: "Maximum 500 caractères",
    sendMessage: "Envoyer le message",
    required: "*"
  },
  success: "Message envoyé avec succès !",
  error: "Échec de l'envoi du message. Veuillez réessayer."
};

export const finalCta = {
  title: "Prêt à booster",
  titleAccent: "vos revenus ?",
  subtitle: "Rejoignez le Programme d'affiliation et diffusez largement votre code personnalisé.",
  getKlark: "Faîtes découvrir Klark",
  learnMore: "En savoir plus",
  guarantees: ["Garantie 30 jours", "Annulation à tout moment"]
};

export const footer = {
  description: "Klark est le 1er cockpit IA qui transforme la façon dont les entrepreneurs créent, exploitent et développent leurs entreprises.",
  sections: {
    product: {
      title: "Produit",
      links: ["Fonctionnalités", "Roadmap", "API", "Sécurité"]
    },
    company: {
      title: "Entreprise",
      links: ["À propos", "Blog", "Carrières", "Contact"]
    },
    support: {
      title: "Support",
      links: ["Centre d'aide", "Confidentialité", "Conditions", "Légal"]
    }
  },
  copyright: "© 2025 Klark. Tous droits réservés.",
  poweredBy: "Fait avec ❤️"
};

export default {
  nav,
  links,
  affiliation,
  hero,
  pricing,
  features,
  perks,
  roadmap,
  testimonials,
  contact,
  finalCta,
  footer
};
